<template>
     <v-card class="elevation-1">
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>{{'prayers._prayers_title_'|translate}}</h4></v-toolbar-title>
    </v-toolbar>
     <v-divider></v-divider>
        <v-card-text class="pa-0">
      <v-list two-line class="pa-0">
          <template v-for="(item, index) in items">
            <v-list-tile
              :key="item.title"
              avatar
              ripple
              @click="toggle(index)"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ formatDate(item.timestamp) }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">{{ item.text }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <!-- <v-list-tile-action-text>{{ item.action }}</v-list-tile-action-text> -->
                <v-icon
                  v-if="selected.indexOf(index) < 0"
                  color="grey lighten-1"
                >
                  star_border
                </v-icon>

                <v-icon
                  v-else
                  color="yellow darken-2"
                >
                  star
                </v-icon>
              </v-list-tile-action>

            </v-list-tile>
            <v-divider
              v-if="index + 1 < items.length"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
        </v-card-text>
      </v-card>
</template>

<script>
import messages from '@/api/message';
import { formatDate } from 'tough-cookie';
export default {

  data: () => ({
    selected: [2],
    items: this.prayers
  }),
  computed: {
    prayers () {
      return this.$store.getters.prayers;
    }
  },
  watch: {
    prayers (val) {
      this.items = val;
    }
  },
  methods: {
    handleClick: (e) => {
      console.log(e);
    },
    formatDate (s) {
      return new Date(s).toLocaleDateString();
    }  
  },

};
</script>



// WEBPACK FOOTER //
// src/components/widgets/list/MessageList.vue